import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { isUserLogin } from '@eureka/utils/account';

export interface PccDownloadStatus {
    sdf: boolean
    smiles: boolean
}

export interface PccSequencesPatent {
    pn: string
    seq_no: string[]
}

export interface PccApi {
    getDownloadStatus(chatId: string): Promise<PccDownloadStatus>;
    getSequences(data: { patents: PccSequencesPatent[] }): Promise<Record<string, Record<string, {hash_id: string; seq_text: string; seq_id?: string}[]>>>;
}

export const PccApi = Symbol('PccApi');

@injectable()
export class PccApiImpl extends PsHttpService implements PccApi {
    get baseUrl() {
        return `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`
    }

    get options() {
        return {
            baseURL: this.baseUrl,
        };
    }

    async getDownloadStatus(chatId: string) {
        const isLogin = await isUserLogin()
        const base = isLogin ? '' : '/guest'
        return this.get<PatSnapCommonResponseData<PccDownloadStatus>>({
            url: `${base}/patent/pcc/download/status`,
            params: { chat_id: chatId },
        }).then((res) => {
            return res as unknown as PccDownloadStatus;
        });
    }

    async getSequences(data: { patents: PccSequencesPatent[] }) {
        const isLogin = await isUserLogin()
        const base = isLogin ? '' : '/guest'
        return this.post<PatSnapCommonResponseData<ReturnType<PccApi['getSequences']>>>({
            url: `${base}/patent/pcc/sequences`,
            data,
        }).then((res) => {
            return res.data as unknown as ReturnType<PccApi['getSequences']>;
        });
    }
}
